import { Component, Input, OnInit } from '@angular/core';
import { DocumentAttribute } from '../models/DocumentAttribute';

@Component({
  selector: 'app-display-attribute',
  templateUrl: './display-attribute.component.html',
  styleUrls: ['./display-attribute.component.css']
})
export class DisplayAttributeComponent implements OnInit {

  @Input() attribute: DocumentAttribute;
  constructor() { }

  ngOnInit() {
  }

}
